import React, { Component } from 'react'
import { ThemeProvider } from 'styled-components'

import DefaultTheme from '../utils/themes/default'
import Header from '../components/Header'

// Styled Components
import { DefaultPageHoc } from './defaultPage.styles'

const defaultPage = WrappedComponent =>
    class extends Component {
        render() {
            return (
                <ThemeProvider theme={DefaultTheme}>
                    <DefaultPageHoc>
                        <Header />
                        <WrappedComponent {...this.props} />
                    </DefaultPageHoc>
                </ThemeProvider>
            )
        }
    }

export default defaultPage



// WEBPACK FOOTER //
// ./src/hocs/defaultPage.js